module.exports = __webpack_public_path__ + "static/media/Dual Ring.b066beb1.svg";